'use client';

import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { addReadToNews } from "@/utils/http";

export default function IdeaReadTracker({ ideaId }) {
    const { mutate: sendRead } = useMutation({
        mutationFn: addReadToNews
    });

    useEffect(() => {
        if (!ideaId) return;
        sendRead({ id: ideaId });
    }, [ideaId, sendRead]);

    return null;
}
